module.exports = __webpack_public_path__ + "static/mr-concert-performance-23-65a43ffcb8a029c1628566fce87ef448.jpg";